import styled, { css } from 'styled-components';

// React-shared.
import { lg } from '@exonet/react-shared/lib/styled';

export const Navbar = styled.section`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 900;

  flex: 0 0 auto;
  background-color: var(--bg);
  box-shadow: var(--navbar-box-shadow);

  height: var(--xs-header-height);
  max-width: 100%;
  margin-bottom: 45px;
  padding-left: var(--xs-padding-horizontal);

  ${({ authorized }) =>
    authorized &&
    css`
      padding-left: 55px;
    `}

  ${lg(css`
    position: relative;
    margin-bottom: inherit;
    height: var(--lg-header-height);
    padding: 0 var(--lg-padding-horizontal);
  `)}
`;

export const Header = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  overflow: hidden;

  > strong {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  > svg {
    height: 20px;
    fill: var(--logo-color);
  }
`;

export const Actions = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;
